<template>
<div class="drop-down-box" ref="dropBox" @click.self.stop="onFocus">
	<template v-for="(relU, index) in formdata" :key="relU.userId">
		<!-- 选择的联系人标签 -->
		<el-tag			
			closable
			effect="dark"
			:disable-transitions="false"
			@close="$emit('closeFlow', index)"
		>{{relU.realname}}</el-tag>
	</template>
	<!-- 输入框 -->
  <template v-if="!data.maxCount ||  Number(data.maxCount) > formdata.length">
    <div class="drop-down-box-input" ref="dropInput">
      <el-input
        :placeholder="placeholder"
        :autofocus="focus"
        ref="input"
        v-model="wd"
        @keyup.enter="contactSearch">
      </el-input>
    </div>
    <i class="iconfont icon-sousuo" :style="isDetaild?{top: '10px'}:''" @click.self.stop="contactSearch"></i>
  </template>

	<!-- 下拉框 -->
	<ul class="drop-down" ref="dropDown" v-show="isShowList" :style="{width:downWidth, top:dropDownTop, left:dropDownLeft}">
		<li v-if="contactLoading || contactList.length==0" class="drop-down-tips" @click.stop>
			{{tips}}
		</li>
		<template v-else>
			<li
				v-for="(user, index) in contactList"
				:class="['drop-down-item', activeIndex===index?'active':'']"
				@click.stop="change(index)"
				@mouseenter="showPopover(index)"
				@mouseleave="hidePopover(index)"
				:key="index"
				>
				<div class="user-info">
					<span class="label-c"
								v-if="isShowLabel"
								:style="{
									backgroundColor: userLabel[user.type] && userLabel[user.type].background,
									color: userLabel[user.type] && userLabel[user.type].color
									}"
								>{{userLabel[user.type] && userLabel[user.type].label || ''}}</span>
					{{ (user.name || user.realname) + (user.phone?`（${user.phone}）`:'') }}
				</div>
				<span class="more-tag" v-if="itemInfo && itemInfo.relationMoreTag && itemInfo.relationMoreTag !== ''">
					{{ getMoreTagContent(user, itemInfo.relationMoreTag) }}
				</span>
				<el-popover	
					placement="right"
					width="200"
					:value="popoverVisible[index]"
					trigger="manual"
				>
					<p>姓名：{{user.name || user.realname}}</p>
					<p>组织：{{ getOrgName(user) }}</p>
					<p v-if="data.isShowID">身份证：{{user.idcard}}</p>
					<p>手机号：{{user.phone}}</p>
					<template #reference>
						<span class="view-info"></span>
					</template>
				</el-popover>
			</li>
		</template>
	</ul>
</div>

</template>

<script>
import { getopenuserlist } from '@/port/clientSide/multipleChoice'
import { getusertiplist } from '@/port/admins/organizationUser'
import { getOrgShowName } from '@/api/global.js'

import typeObj from "@/components/common/multipleChoice/color";

export default {
	name: 'userDropDown',
	data () {
		return {
			wd: '',
			contactLoading: false,
			contactList: [],
			isShowList: false,
      isShowLabel: true,
			tips: '加载中...',
			userLabel: '', // 用户标签
			activeIndex: '', // 选中的
			focus: false,
			dropDownLeft: 0,
			dropDownTop: 0,
			downWidth: 0,
			popoverVisible: {}, // 用于控制每个popover的显示状态
		}
	},
	props:{
		placeholder: {
			type: String,
			default: '输入搜索'
		},
		data: {
		},
		formdata: {

		},
		isDetaild: {
			type: Boolean,
			default: false
		},
		itemInfo: {
			type: Object,
			default: () => {}
		}
	},
	methods: {
		getOrgName(user) {
			const li = user.orglst
			if (!li) return user.orgname || user['部门']
			return getOrgShowName(li[0])
		},
		onFocus () {
			this.$refs.input.focus()
		},
		// 获取用户标签
		async getUserType () {
      const res = await getusertiplist({
        curpage: 1,
        pagesize: 99999
      })
      if (res.code === 0) {
        const obj = {}
        for (const i of res.data) {
          obj[i.keytype] = {
            label: i.name,
            color: typeObj[i.colours].color,
            background: typeObj[i.colours].background
          }
        }
        this.userLabel = obj
      }
    },
		// 搜索
		async contactSearch(e){
			// 如果列表显示就不搜索
			if (this.wd == '') return this.$message.warning('请输入您要搜索的人员！')
			if (!this.isShowList) {
				// 获取下拉框宽度
				this.getDownWidth()
				this.getDownSeat()
				e.stopPropagation();
				const userMsg = JSON.parse(localStorage.getItem('userMsg'))
				const organizations = userMsg.organizations // 所在部门
				const roles = userMsg.roles // 所属用户
				this.isShowList = true
				this.contactLoading = true
				// 搜索重置
				this.activeIndex = ''
				this.tips = '加载中...'
				// 开始搜索
				const query = {
					curpage: 1,
					pagesize: 100,
				}
				if (this.data.isEnterChoice) {
					query.name = this.wd
				} else {
					query.names = this.wd
				}
				//部门查看范围。1:本部门不含子部门,2:本部门及其子部门,3:全部部门,4:自定义,5是无
				switch (this.data.lookRMSIsUser) {
					case 1:{
						query.organizationIdss = organizations
						break
					}
					case 2:{
						query.organizationIdss = organizations
						break
					}
					case 4:{
						if (this.data.lookCustomArr.length > 0) {
							const arr = JSON.parse(this.data.lookCustomArr).map(item=>{
								return item.organizationId
							})
							query.organizationsId = arr.toString()
						}
						break
					}
				}

				//角色查看范围。1:所在角色,2:全部角色,3:自定义,4:无
				switch (this.data.lookRMSIsUserRole) {
					case 1:{
						query.rolesId = roles
						break
					}
					case 3:{
						if (this.data.lookCustomArrRole.length > 0) {
							const arr = JSON.parse(this.data.lookCustomArrRole).map(item=>{
								return item.roleId
							})
							query.rolesId = arr.toString()
						}
						break
					}
				}
				const {code, data} = await getopenuserlist(query)
				console.log(code, data);
				// 有搜出来就显示
				if (code === 0) {

					if (data.length!==0) {
						this.contactList = data
						// 如果没有选中就默认选择第一个
						if (this.activeIndex == '') {
							this.activeIndex = 0
						}
						this.contactLoading = false
						// 打开列表就监听键盘
						document.addEventListener('keyup', this.keyChange)
					} else {
						this.tips = '查无此人'
					}
				} else {
					this.$message.error('搜素失败！')
					this.isShowList = false
				}
			}
		},
		// 关闭列表
		closeDropDown () {
			this.isShowList = false
			document.removeEventListener('keyup', this.keyChange)
		},
		// 选择
		change (index) {
			this.activeIndex = index
			let userArr = [this.contactList[this.activeIndex]]
			// 是否支持多选

			if (this.data.singleIsUser === 1) {
				const isCheck = this.formdata.some(item=>{
					return item.userId == userArr[0].userId
				})
				userArr = isCheck ? this.formdata : [...this.formdata, ...userArr]
			}

			// return
			this.$emit('userCheck', {user: userArr, data: this.data})
			// 关闭重置
			this.isShowList = false
			this.activeIndex = ''
			this.tips = '加载中...'
			this.wd = ''
		},
		// 键盘选择
		keyChange (e) {
			switch (e.keyCode) {
				// 上
				case 38 : {
					this.activeIndex > 0 ? this.activeIndex-- : ''
					break
				}
				// 下
				case 40 : {
					this.activeIndex < this.contactList.length - 1 ? this.activeIndex++ : ''
					break
				}
				// 回车
				case 13 : {
					console.log('回车');
					this.change(this.activeIndex)
					break
				}
			}
		},
			// 获取下拉框宽度
		getDownWidth () {
			const el = this.$refs.dropBox
			this.downWidth = el.offsetWidth < 320 ? '320px' : el.offsetWidth + 'px'
			// this.downWidth = el.offsetWidth + 'px'
		},
		getDownSeat() {
			this.dropDownLeft = this.$refs.dropInput.getBoundingClientRect().left - 2 + 'px'
			this.dropDownTop = this.$refs.dropInput.getBoundingClientRect().top + 35 + 'px'
		},
		showPopover(index) {
			// this.$set(this.popoverVisible, index, true)
			this.popoverVisible[index] = true
		},
		hidePopover(index) {
			// this.$set(this.popoverVisible, index, false)
			this.popoverVisible[index] = false
		},
		// 更多标签显示
		getMoreTagContent(user, relationMoreTag) {
			if (relationMoreTag === 'sex') {
				return user[relationMoreTag] === 0 ? '男' : '女'
			} else if (relationMoreTag === 'orgname' || relationMoreTag === '部门') {
				const content = user[relationMoreTag] || ''
				return content.includes(',') ? content.split(',')[0] : content
			} else {
				return user[relationMoreTag]
			}
		},
	},
	watch: {
		wd (val) {
			if (val) {
				this.isShowList = false
			}
		}
	}, 

	mounted () {
		// 获取下拉框宽度
		this.getUserType()
		this.getDownWidth()
    this.isShowLabel = this.$apiurl === 'http://10.66.99.244' || this.$apiurl === 'http://10.66.99.244:8088' || this.$apiurl === 'http://app.itgedu.com.cn' ? false :true
		document.addEventListener('click', this.closeDropDown)
		document.body.appendChild(this.$refs.dropDown)
	},
	beforeUnmount () {
		document.removeEventListener('click', this.closeDropDown)
		document.body.removeChild(this.$refs.dropDown)
	},

}
</script>

<style lang="scss" scoped>
:deep(.el-input .el-input__inner) {
	border: none !important;
}

:deep(.el-tag) {
	margin-left: 10px;
}

:deep(.el-tag--dark),
:deep(.el-tag--dark.el-tag--primary) {
	background-color: #4e86ff !important;
	border-color: #4e86ff !important;
	color: #fff !important;
}

.drop-down-box {
	width: inherit;
	border: 1px solid #CCCCCC;
	border-radius: 4px;
	i{
		position: absolute;
		display: inline-block;
		width: 16px;
		height: 16px;
		top: 4px;
		right: 12px;
		cursor: pointer;
	}
	&-input {
		position: relative;
		display: inline-block;
		width: 200px;
		min-height: 38px;
		:deep(.el-input__wrapper) {
			box-shadow: none;
		}
	}
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #4dabee;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
.drop-down {
  position: fixed;
	margin-top: 10px;
	width: inherit;
	max-height: 200px;
	overflow: hidden;
	overflow-y:auto;
  padding: 6px 0px;
	background: #FFF;
  border: 1px solid #E4E7ED;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	z-index: 4999;
  &::before{
    display: block;
    content: " ";
    position: absolute;
    top: -4px;
    left: 40px;
    width: 6px;
    height: 6px;
    background: #FFF;
    border-left: 1px solid #E4E7ED;
    border-top: 1px solid #E4E7ED;
    transform: rotate(45deg);
  }
	li {
		height: 40px;
		line-height: 40px;
		clear: both;
		overflow: hidden;
	}
	&-tips{
		text-align: center;
	}
  &-item{
    list-style: none;
		padding: 0 7px 0 10px;
		cursor: pointer;
		.label-c {
			font-size: 12px;
			padding: 2px 4px;
		}
		.user-info {
			float: left;
		}
		.more-tag {
			float: left;
			display: inline-block;
			max-width: 40%;
			margin: 11px 0 0 10px;
			height: 18px;
			line-height: 18px;
			text-align: center;
			color: #3AB380;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			background-color: rgba(112, 255, 189, 0.1);
		}
		.view-info {
			width: 24px;
			color:#057EFF;
			font-size: 12px;
			float: right;
			margin-left: 4px;
			height: 40px;
			line-height: 40px;
		}
		&:hover{
			background: rgb(245, 247, 250);
			font-weight: 700;
			color: #4e86ff;
		}

  }
	.active{
		background: rgb(245, 247, 250);
		font-weight: 700;
		color: #4e86ff;
	}
}
</style>
